module.exports = __webpack_public_path__ + "static/gallery_yarra_5_thumb-5a9f860252b0272ac0e1b7b48378906e.jpg";